export const worklistCopyFr = {
    worklist: "Liste de tâches",
    yourTasks: "Vos tâches",
    description:
        "Complétez les formulaires cliniciens, les consentements et les informations d'événement manquantes pour l'ensemble de vos patients.",
    emptyTitle: "Vous êtes à jour",
    emptyDescription: "Aucune tâche clinicien en attente pour le moment.",
    noMatchingTasks: "Aucune tâche correspondante",
    noMatchingTasksDescription: "Essayez de modifier votre recherche, l'onglet ou les filtres.",
    complete: "Compléter",
    completeDetails: "Compléter les informations",
    completeDetailsPanelDescription: "Renseignez les informations manquantes, puis revenez à votre liste de tâches.",
    signConsent: "Signer le consentement",
    closePanel: "Fermer le panneau",
    noTaskSelected: "Sélectionnez une tâche",
    noTaskSelectedDescription:
        "Choisissez une ligne pour compléter ici un formulaire, un consentement ou des informations d'événement manquantes.",
    openDiary: "Ouvrir le journal",
    openPatient: "Ouvrir le patient",
    toDo: "À faire",
    refresh: "Actualiser",
    forms: "Formulaires",
    details: "Informations",
    archived: "Archivées",
    archive: "Archiver",
    archiveAll: "Tout archiver",
    restoreAll: "Tout restaurer",
    tasksSelected: (count: number) => (count === 1 ? "1 tâche sélectionnée" : `${count} tâches sélectionnées`),
    selectedTasksDescription: "Choisissez une action pour les tâches sélectionnées.",
    selectTask: "Sélectionner la tâche",
    selectAllTasks: "Sélectionner toutes les tâches",
    restore: "Restaurer",
    archiveSucceeded: (count: number) => (count === 1 ? "Tâche archivée." : `${count} tâches archivées.`),
    archiveFailed: "Impossible d'archiver cette tâche. Veuillez réessayer.",
    restoreSucceeded: (count: number) => (count === 1 ? "Tâche restaurée." : `${count} tâches restaurées.`),
    restoreFailed: "Impossible de restaurer cette tâche. Veuillez réessayer.",
    emptyArchivedTitle: "Rien d'archivé",
    emptyArchivedDescription: "Les tâches que vous archivez restent ici jusqu'à ce que vous les restauriez.",
    allPeople: "Toutes les personnes",
    peopleFilterLabel: "Personnes",
    selectPeople: "Sélectionner des cliniciens",
    organisationFilterLabel: "Organisation",
    allOrganisations: "Toutes les organisations",
    taskTypeFilterLabel: "Type de tâche",
    allTaskTypes: "Tous les types de tâches",
    searchTasks: "Rechercher des tâches",
    clearSearch: "Effacer la recherche de tâches",
    filterTasks: "Filtrer les tâches",
    filterTasksDescription: "Choisissez les personnes, l'organisation et le type de tâche.",
    taskCompleteTitle: "Tâche enregistrée",
    taskCompleteDescription: "Passez à la personne suivante de votre liste de tâches quand vous le souhaitez.",
    taskCompleteAllDoneTitle: "Tout est terminé",
    taskCompleteAllDoneDescription: "Il n'y a plus de tâches dans cette liste.",
    continueToNextTask: "Passer à la tâche suivante",
    doNext: "À faire ensuite",
    doNextDescription: (task: string, patientName: string, hospitalNumber: string | null) =>
        hospitalNumber
            ? `${task} pour ${patientName}. Numéro de dossier hospitalier : ${hospitalNumber}`
            : `${task} pour ${patientName}`,
    nextPatientTask: (name: string) => `Suivant : ${name}`,
    returnToWorklist: "Retour à la liste de tâches",
    patient: "Patient",
    hospitalNumber: "Numéro de dossier hospitalier",
    task: "Tâche",
    injectionDetailsTask: "Informations sur l'injection",
    surgeryDetailsTask: "Informations sur l'opération",
    shockwaveDetailsTask: "Informations sur les ondes de choc",
    procedureDetailsTask: "Informations sur l'intervention",
    consentTask: "Consentement",
    due: "Échéance",
    status: "Statut",
    actions: "Actions",
    dueLabel: "À faire",
    blockedLabel: "Bloquée",
    incompleteLabel: "Incomplète",
    blockedBy: (blocker: string) => `Complétez d'abord : ${blocker}`,
    truncatedNotice: (total: number, shown: number) =>
        `Affichage des ${shown} premiers journaux sur ${total} comportant des formulaires cliniciens. Affinez votre liste de patients pour voir les autres.`,
    unknownPatient: "Patient inconnu",
    notDefined: "Non défini",
    loading: "Chargement de la liste de tâches…",
    errorLoading: (message: string) => `Impossible de charger la liste de tâches : ${message}`,
    taskCount: (count: number) => (count === 1 ? "1 tâche" : `${count} tâches`),
};
